import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin/admin.component';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { UsersComponent } from './users/users.component';
import { TarifsComponent } from './tarifs/tarifs.component';
import { ListsComponent } from './lists/lists.component';
import { TypePrestationsComponent } from './type-prestations/type-prestations.component';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { PanelModule } from 'primeng/panel';
import { TypeExpertisesComponent } from './type-expertises/type-expertises.component';

@NgModule({
  declarations: [AdminComponent, UsersComponent, TarifsComponent, ListsComponent, TypePrestationsComponent, TypeExpertisesComponent],
  imports: [
    CommonModule,
    AdminRoutingModule,
    MatCardModule,
    MatTabsModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ButtonModule,
    DropdownModule,
    PanelModule
  ],
  exports: [
  	AdminComponent
  ]
})
export class AdminModule { }
